import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useRef } from "react";

const DrawingManagerPolygonEditor = ({ onCreate }) => {
  const map = useMap();
  const mapLibCore = useMapsLibrary("core");
  const mapLibMaps = useMapsLibrary("maps");
  const mapLibMarker = useMapsLibrary("marker");
  const mapLibGeometry = useMapsLibrary("geometry");
  const polygonRef = useRef(null);
  // const isDrawing = useRef(false);
  // const center = useRef(null);
  // const centerMarkerRef = useRef(null);
  // const radiusMarkerRef = useRef(null);

  // const map = useMap();
  // const polygonRef = useRef(null);
  const tempPath = useRef([]);
  // const vertexMarkers = useRef([]);

  useEffect(() => {
    if (!map || !mapLibCore || !mapLibMaps || !mapLibMarker || !mapLibGeometry)
      return;

    let clickListener, dblClickListener;

    clickListener = map.addListener("click", (e) => {
      tempPath.current.push(e.latLng);

      if (!polygonRef.current) {
        polygonRef.current = new mapLibMaps.Polygon({
          map,
          paths: tempPath.current,
          strokeColor: "#1976D2",
          fillColor: "#1976D2",
          fillOpacity: 0.2,
          strokeWeight: 2,
          editable: true,
          draggable: false,
          clickable: true,
          type: "polygon",
        });

        let mouseUpListener;

        mouseUpListener = polygonRef.current.addListener(
          "mouseup",
          (polyMouseEvent) => {
            if (polyMouseEvent.vertex !== undefined) {
              if (onCreate) {
                onCreate(polygonRef.current);
                mapLibCore.event.removeListener(mouseUpListener);
                polygonRef.current.setDraggable(true);
                polygonRef.current = undefined;
              }
            }
          }
        );
      } else {
        polygonRef.current.setPath(tempPath.current);
      }
    });

    dblClickListener = map.addListener("dblclick", () => {
      map.setOptions({ draggable: true });
      if (!polygonRef.current) return;

      // Create draggable vertex markers
      // polygonRef.current.getPath().forEach((latLng, i) => {
      //   const div = document.createElement("div");
      //   div.style.width = "10px";
      //   div.style.height = "10px";
      //   div.style.border = "2px solid white";
      //   div.style.borderRadius = "50%";
      //   div.style.background = "#1976D2";

      //   const marker = new mapLibMarker.AdvancedMarkerElement({
      //     map,
      //     position: latLng,
      //     content: div,
      //     gmpDraggable: true,
      //   });

      //   marker.addListener("drag", (ev) => {
      //     const path = polygonRef.current.getPath();
      //     path.setAt(i, ev.latLng);
      //   });

      //   vertexMarkers.current.push(marker);
      // });

      mapLibCore.event.removeListener(clickListener);
      mapLibCore.event.removeListener(dblClickListener);
    });

    return () => {
      if (clickListener) mapLibCore.event.removeListener(clickListener);
      if (dblClickListener) mapLibCore.event.removeListener(dblClickListener);
      if (polygonRef.current) polygonRef.current.setMap(null);
      // vertexMarkers.current.forEach((m) => (m.map = null));
    };
  }, [mapLibCore, mapLibMarker, mapLibMaps, mapLibGeometry]);

  return null;

  // useEffect(() => {
  //   if (!map || !mapLibCore || !mapLibMaps || !mapLibMarker || !mapLibGeometry)
  //     return;

  //   let mouseUpListener;

  //   mouseUpListener = map.addListener("mouseup", () => {
  //     console.log("mouseup");
  //     if (isDrawing.current) {
  //       isDrawing.current = false;
  //       map.setOptions({ draggable: true });
  //       if (onCreate) {
  //         onCreate(circleRef.current);
  //       }
  //     }
  //     else {
  //       isDrawing.current = true;
  //       polygonRef.current = new mapLibMaps.Polygon({
  //         map,
  //         paths:
  //       })
  //     }
  //   });

  //   return () => {
  //     console.log("cleanup");

  //     try {
  //       mapLibCore.event.removeListener(mouseDownListener);
  //       mapLibCore.event.removeListener(mouseMoveListener);
  //       mapLibCore.event.removeListener(mouseUpListener);
  //       // if (circleRef.current) circleRef.current.setMap(null);
  //       // if (radiusMarkerRef.current) radiusMarkerRef.current.map = null;
  //     } catch (error) {}
  //   };
  // }, [mapLibCore, mapLibMarker, mapLibMaps, mapLibGeometry]);

  // return null;
};

export default DrawingManagerPolygonEditor;
